module.exports = __webpack_public_path__ + "img/func-bg-1.5b9cabd1.png";